import router from '../router'
import { Message } from 'element-ui'


export const setSearchParams = function(params,page_size,page,order,sort){
  let searchParams = {
    filter:{},
    op:{},
  }
  for(let item in params){
    let value = params[item].value
    let isTrue =((typeof value=='string')&&value.length != 0 )|| (Array.isArray(value)&&value.length!=0) || (typeof value=='number')
    if(isTrue){
      searchParams.filter[item] = value
      if(params[item].op){
        searchParams.op[item]= params[item].op
      } else {
        searchParams.op[item]= '='
      }
    }
    
  }
  if(page_size){
    searchParams.page_size = page_size
  }

  if(page){
    searchParams.page = page
  }

  if(order){
    searchParams.order = order
  }

  if(sort){
    searchParams.sort = sort
  }
  return searchParams
}

export const setApiUrl = function(){
  let url = window.location.href;
  let api = 'http://'
  if (url.indexOf('localhost')>0){
    api += 'api.velocitypublic2.top/index.php'
  }else if (url.indexOf('velocitypublic-dev2.cn:9999/')>0){
    api += 'api.velocitypublic-dev2.cn/index.php'
  }else if(url.indexOf('velocitypublic.com')>0){
    api += 'api.velocitypublic.com/index.php'
  }else if(url.indexOf('velocitypublic-dev.cn')>0){
    api += 'velocitypublic-dev.cn:8888'
  }else if(url.indexOf('192.168.1')>0){
    api += 'api.velocitypublic.top/index.php'
  }else if(url.indexOf('velocitypublic.top')>0){
    api += 'api.velocitypublic.top/index.php'
  }else if(url.indexOf('pre.velocitypublic.cn')>0){
    api += 'pre.api.velocitypublic.cn/index.php'
  }else if (url.indexOf('velocitypublic.cn')>0){
    api = 'https://api.velocitypublic.cn/index.php'
  }
  return api
}


export const setUrlApi = () => {
  let host = location.hostname
  let hosts = {
    'velocitypublic.top': 'api.velocitypublic.top',
    'velocitypublic.com': 'api.velocitypublic.com',
    'pre.velocitypublic.cn': 'pre.api.velocitypublic.cn',
    'velocitypublic.cn': 'api.velocitypublic.cn',
  }
  return hosts[host] ? `${location.protocol}//${hosts[host]}` : ''
}

//获取cookie
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
  return (arr[2]);
  else
  return null;
}
//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};
   
//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
  document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

export  const  appendStatus = function(list){
  for(let item in list){
    if(list[item].status =="normal"){
      list[item].statusBoolean = true
    }else{
      list[item].statusBoolean = false
    }
    if(list[item].childlist && list[item].childlist.length>0){
      appendStatus(list[item].childlist)
    }
  }
  return list
}

export const  downloadCodeImg =function(imgSrc,name){
  var image = new Image();
  console.log(imgSrc,'图片下载')
  image.setAttribute("crossOrigin", "*");
  image.onload = function() {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    var a = document.createElement("a"); // 生成一个a元素
    var event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgSrc;
  image.onerror = function(){
    Message({message:'图片不存在',type:'error'}) //一次只提醒一条报错信息
  }

}

let perssion = []
export const setMenuList = function(menuList){
  perssion = ['/expired']
  let routerObj =[ {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: { title: '登录',status: "hidden"},
  },
  {
    path: '/expired',
    name: 'expired',
    component: () => import('../views/expired.vue'),
    meta: { title: '登录超时',hidden:true},
  },]
  if(menuList && menuList.length>0){
    for(let i = 0; i < menuList.length; i++){
      let res = setMenuItem(menuList[i])
      routerObj.push(res)
    }
  }
  let welcome =    {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/home/welcome.vue'),
    meta: { title: '欢迎' }
  }
  routerObj.forEach(element => {
    if(element.path == '/'){
      if(!element.children){
        element.children = []
      }
      element.children.push(welcome)
      element.redirect = '/welcome'
      perssion.push('/welcome')
    }
  });
  if(perssion.indexOf('/welcome') == -1){
    let welcomeObj = {
      path: '/',
      name: 'Home',
      component: import('@/views/index.vue'),
      meta: { title: '系统设置',hidden:false},
      children: [welcome]
    }
    routerObj.push(welcomeObj)
    perssion.push('/welcome')
  }
  perssion.push('/refresh')
  localStorage.setItem('permission',JSON.stringify(perssion))
  return routerObj
}
const setMenuItem = function(item){
  let routerItem = {
    path:item.path,
    name:item.name,
    icon:item.icon,
    meta:{
      title:item.name,
      status:item.status,
      btnPersssion:[]
    },
    component: () => {
      if(item.path === '/admin_log'){
        return import('../views/home/ManageLog/index.vue')
      }else  if(item.path === '/rule'){
        return import('../views/home/ManageMenu/index.vue')
      }else  if(item.path === '/system'){
        return import('@/views/home/ManageSystem/index.vue')
      }else  if(item.path === '/admin'){
        return import('@/views/home/ManageUser/index.vue')
      }else  if(item.path === '/'){
        return import('@/views/index.vue')
      }
    },
    children:[]
  }

  if(item.status == 'normal'){
    perssion.push(item.path)
  }

  if(item.childlist && item.childlist.length > 0){
    for(let i = 0; i < item.childlist.length; i++){
      if(item.childlist[i].is_menu){
        let child = setMenuItem(item.childlist[i])
        routerItem.children.push(child)
      }else{
        routerItem.meta.btnPersssion.push(item.childlist[i])
      }
      if(item.childlist[i].status == 'normal' &&item.status == 'normal'){
        perssion.push(item.childlist[i].path)
      }
    }
  }
  if(item.path == '/role'){
    routerItem.meta.status = 'hidden'
  }
  return routerItem
 
}

export const hasPermission = userPermission => {
  // 当前按钮列表，我是用本地缓存存储
  let btnPermissionList = JSON.parse(localStorage.getItem('permission'))
  // 因为后台返回的不是以按钮名的数组，所以需要过滤
  let eglishPermission = btnPermissionList.map((v, i) => {
      return v
  })
  // 是否在权限数组里面
  let status = eglishPermission.includes(userPermission)
  return status
}

